import { useState } from "react";
import { useMutation } from "react-query";
import ManageBlogForm from "../forms/ManageBlogsForm/ManageBlogForm";
import { useAppContext } from "../contexts/AppContext";
import * as apiClient from "../api-client";
import { useNavigate } from "react-router-dom";

const AddBlog = () => {
  const { showToast } = useAppContext();
  const [isSaving, setSaving] = useState(false);
  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation(apiClient.addBlog, {
    onSuccess: () => {
      showToast({ message: "Blog Saved!", type: "SUCCESS" });
      setSaving(false); // Reset saving state
      navigate('/blogs')
      // Clear form fields
      document.querySelector("form")?.reset();
    },
    onError: () => {
      showToast({ message: "Error Saving Blog", type: "ERROR" });
      setSaving(false); // Reset saving state
    },
  });

  const handleSave = (blogFormData: FormData) => {
    mutate(blogFormData);
  };

  return <ManageBlogForm onSave={handleSave} isLoading={isLoading} isSaving={isSaving} setSaving={setSaving} />;
};

export default AddBlog;
